// Chakra imports
import { Flex, FormControl, FormLabel, Spinner, SimpleGrid, Button, LightMode, useColorModeValue , Icon } from '@chakra-ui/react';


import { RiFileExcel2Line } from 'react-icons/ri';


export default function Actions(props: {
	[x: string]: any;
	onExport: any;
	disabledActions: boolean;
	showProgressExport: boolean;
}) {
	
	const handlerExportClick = async () => {
		props.onExport();
	};

	return (
		<FormControl>
                        <Flex flexDirection={{ base: 'column', md: 'row' }} mt='15px'>
						<LightMode>
				<Button
					colorScheme='green'
					variant='outline'
					p='15px 40px'
					fontSize='sm'
					onClick={handlerExportClick}
					isDisabled={props.disabledActions}
					fontWeight='500'
					ms={{ base: '0', md: 'auto' }}
					mb={{ base: '20px', md: '0' }}
					me={{ base: '0', md: '20px' }}
					_hover={{ bg: 'whiteAlpha.100' }}
					_focus={{ bg: 'transparent' }}
					_active={{ bg: 'transparent' }}>
					<Icon as={RiFileExcel2Line} width='20px' height='20px' color='inherit' mr='10px' /> Exportar a Excel
          <Spinner
              size='sm'
			  ml='5px'
			  hidden={!props.showProgressExport}
            />
				</Button>
			</LightMode>
                        </Flex>	
		</FormControl>
	);
}
